export const stateMapping = {
    stateToRoute(uiState) {
        const indexUiState = uiState['tag'];
        return {
            q: indexUiState.query,
        };
    },
    routeToState(routeState) {
        return {
            tag: {
                query: routeState.q,
            },
        };
    },
};
